import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useRecentlyViewedContext } from "@/_MiniApps/RecentlyViewedContext/RecentlyViewedContext";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
var RecentlyViewed = function RecentlyViewed() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useRecentlyViewedCon = useRecentlyViewedContext(),
    renderAllRecentlyViewed = _useRecentlyViewedCon.renderAllRecentlyViewed;
  if (__IS_SSR__) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout
  //   hasNavBar
  , {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
    }, /*#__PURE__*/React.createElement("div", {
      id: "recent-side-menu-toggle",
      className: "en:transform en:rotate-180",
      onClick: function onClick() {
        history.back();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--arrow-forward-ios-rounded",
      width: 4,
      height: 4,
      color: "#3c56d4"
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-sm flex items-center text-primary font-bold m-auto"
    }, t("recently_viewed_cars", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4"
    }))
  }, renderAllRecentlyViewed()));
};
export default RecentlyViewed;